<p-breadcrumb
  [model]="[
    { label: 'Categorias', routerLink: ['/categories'] },
    {
      label: categoryId() ? 'Editar Categoria' : 'Nova Categoria',
      routerLink: categoryId()
        ? ['/categories/update/' + categoryId()]
        : ['/categories/create']
    }
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="relative">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex flex-wrap justify-between items-center">
      <div>
        @if(categoryId()){
        <h5 class="font-bold">Editar Categoria</h5>
        <p>Confira e atualize informações</p>
        }@else {
        <h5 class="font-bold">Cadastrar Nova Categoria</h5>
        <p>Preencha os campos abaixo para cadastrar</p>
        }
      </div>
      <div class="flex justify-end gap-5 items-center">
        @if(categoryId()){
        <div class="w-full flex items-center gap-1">
          <label for="isActive"> Status: </label><br />
          <div class="flex gap-2 items-center">
            <p-toggleswitch formControlName="isActive" />
            {{ formGroup.get("isActive")!.value ? "Ativo" : "Inativo" }}
          </div>
        </div>
        }
        <div class="flex gap-2">
          <p-button
            label="Cancelar"
            routerLink="/categories"
            severity="secondary"
            rounded
            class="btn-secondary-outline"
          >
          </p-button>
          <p-button type="submit" label="Salvar" rounded></p-button>
        </div>
      </div>
    </div>
  </p-toolbar>

  <div class="card mt-5 space-y-5">
    <h5 class="font-bold">Informações gerais</h5>

    <div class="w-full">
      <label for="name"> Nome *</label>
      <input
        pInputText
        type="text"
        formControlName="name"
        class="w-full"
        placeholder="Informe o nome"
      />

      <app-form-error [control]="formGroup.get('name')" />
      <app-form-server-error [control]="formGroup.get('name')" />
    </div>

    <div class="w-full">
      <label for="name"> Categoria Pai</label>
      <div>
        <p-select
          [options]="categoriesDropdown()"
          [loading]="selectLoading()"
          formControlName="parentCategoryId"
          optionLabel="label"
          [filter]="true"
          filterBy="label"
          [showClear]="true"
          placeholder="Selecione uma categoria pai"
          class="w-ful"
          fluid
        >
        </p-select>
      </div>

      <app-form-error [control]="formGroup.get('parentCategoryId')" />
      <app-form-server-error [control]="formGroup.get('parentCategoryId')" />
    </div>

    <div class="w-full">
      <label for="description"> Descrição</label>
      <input
        pInputText
        type="text"
        formControlName="description"
        class="w-full"
        placeholder="Informe a descrição"
      />

      <app-form-error [control]="formGroup.get('description')" />
      <app-form-server-error [control]="formGroup.get('description')" />
    </div>
  </div>

  @if(loading()){
  <div
    class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
  >
    <p-progress-spinner ariaLabel="loading" />
  </div>
  }
</form>
